import {
  algoliaSearch,
  AlgoliaSearchParams,
} from "../../../../api/postCall/algoliaSearch";
import { getBearerToken } from "../../../../api/postCall/bearerToken";
import {
  AlgoliaSearchResponse,
  Hit,
} from "../../../../data-model/algoliaSearchModel";
import { AuthStatusOptionModel } from "../../../../data-model/authStatusOptions";
import { MyMedicalPaOrdersTableData } from "../../../../data-model/tablesData";
import { MyMedicalPaOrdersState } from "../hooks/useMyPaOrdersTableData";
import { generateMyMedicalPaOrdersTableDataFromAlgoliaRecords } from "../utils/generateTableDataFromAlgoliaRecords";

export const makePostCallForNextPagesDataFetch = async (
  payload: AlgoliaSearchParams,
  authStatusOptions: AuthStatusOptionModel[],
  setMyMedicalPaOrdersState: React.Dispatch<
    React.SetStateAction<MyMedicalPaOrdersState>
  >,
  setTableData: React.Dispatch<
    React.SetStateAction<MyMedicalPaOrdersTableData[]>
  >,
) => {
  setMyMedicalPaOrdersState((prev) => ({ ...prev, showinLineLoader: true }));
  try {
    await getBearerToken();
    const response = await algoliaSearch(payload);
    const data: AlgoliaSearchResponse = JSON.parse(
      response,
    ) as AlgoliaSearchResponse;
    setMyMedicalPaOrdersState((prev) => ({
      ...prev,
      data: {
        ...data,
        hits: appendHitsToExistingTableData(
          prev.data?.hits ?? [],
          data?.hits ?? [],
        ),
      },
    }));
    setTableData((prev) => [
      ...prev,
      ...generateMyMedicalPaOrdersTableDataFromAlgoliaRecords(
        data.hits ?? [],
        authStatusOptions,
      ),
    ]);
  } catch (error) {
    setMyMedicalPaOrdersState((prev) => ({ ...prev, error: error as string }));
  } finally {
    setMyMedicalPaOrdersState((prev) => ({ ...prev, showinLineLoader: false }));
  }
};

const appendHitsToExistingTableData = (
  existingTableData: Hit[],
  newHits: Hit[],
) => {
  return existingTableData.concat(newHits);
};
